import { render, staticRenderFns } from "./LicenseSettings.vue?vue&type=template&id=722cda4d"
import script from "./LicenseSettings.vue?vue&type=script&lang=js"
export * from "./LicenseSettings.vue?vue&type=script&lang=js"
import style0 from "./LicenseSettings.vue?vue&type=style&index=0&id=722cda4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports